import script from "./StoreCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreCard.vue?vue&type=script&setup=true&lang=ts"

import "./StoreCard.vue?vue&type=style&index=0&id=63b14f9f&scoped=true&lang=css"

import exportComponent from "/var/www/twledodo-booking-minsuizenraku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b14f9f"]])

export default __exports__